/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-lines */
import {
  Autocomplete,
  Box,
  createFilterOptions,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { OccupationListEN, OccupationListES } from './OccupationList';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { emplomentStyles as classes } from './EmploymentStyles';
import {
  EMPLOYED,
  EMPSTATUS_LABEL,
  EMPSTATUS_LABEL_PROG,
  OCC_PLACEHOLDER,
  PLEASE_SELECT,
  PROGRESA_CONTIGO,
  REQUIRED,
  PROFESSION_DETAILS,
  EMPLOYER_DETAILS,
  EMP_PLACEHOLDER,
} from '../../../constants';

import { autoCompleteOccupation, employedCommon, isBundle, commonTernary } from '../../commonCode';
import { CommonStyles } from '../CommonStyles';
import { productMapping } from '../../../services/productMapping';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';

function Employed({ isBundleCompliance = false }) {
  const { t } = useTranslation();
  const [occupations, setOccupations] = useState([]);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { language, theme, productName } = leadGenerationContext;
  const commonStyles = CommonStyles(theme);
  const styledClasses = ProductUIStyles(theme);
  useEffect(() => {
    if (language === 'EN') {
      setOccupations(OccupationListEN());
    }
    if (language === 'ES') {
      setOccupations(OccupationListES());
    }
  }, [leadGenerationContext.language]);

  const handleChange = (e) => {
    const { setEmploymentInformationErrors, employmentInformationErrors } = leadGenerationContext;
    leadGenerationContext.setIsScreenFourDirty(true);
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setEmploymentInformation({
      ...leadGenerationContext.employmentInformation,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'employer') {
      employedCommon(e, leadGenerationContext, '* Invalid Employer Name');
    } else if (e.target.value.length === 0) {
      setEmploymentInformationErrors({
        ...employmentInformationErrors,
        [e.target.name]: '* Mandatory Field',
      });
    } else {
      setEmploymentInformationErrors({
        ...employmentInformationErrors,
        [e.target.name]: '',
      });
    }
  };

  const handleAutoCompleteChangeEmployed = (name, value) => {
    autoCompleteOccupation(name, value, leadGenerationContext);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option,
  });
  const sortedOccupation = [...occupations].sort((a, b) => a.localeCompare(b));
  return (
    <>
      {' '}
      {leadGenerationContext.productName === PROGRESA_CONTIGO && (
        <Grid size={{ xs: 12, md: 6 }} sx={classes.employment_select_field_padding}>
          <InputLabel
            htmlFor="employmentStatus"
            required
            id="employmentStatus_label"
            aria-label={`${t(EMPSTATUS_LABEL, {
              defaultValue: EMPSTATUS_LABEL,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            sx={commonStyles.label_title}
          >
            {productMapping(leadGenerationContext.productName) === 'Elite Account' ||
            productMapping(leadGenerationContext.productName) === 'Libre' ||
            productMapping(leadGenerationContext.productName) === 'Ahorra'
              ? t('Employment Status Prog', {
                  defaultValue: EMPSTATUS_LABEL_PROG,
                  nsSeparator: '|',
                })
              : t(EMPSTATUS_LABEL, { defaultValue: EMPSTATUS_LABEL })}
          </InputLabel>
          <OutlinedInput
            id="employmentStatus"
            name="employmentStatus"
            inputProps={{ maxLength: 100 }}
            data-testid="employer_testid"
            sx={[commonStyles.outlined_inputs_empStatus, classes.input_disabled_style]}
            onChange={handleChange}
            placeholder={t(EMPLOYED, {
              defaultValue: EMPLOYED,
              nsSeparator: '|',
            })}
            fullWidth
            disabled
            value={t(leadGenerationContext.employmentInformation.employmentStatus, {
              defaultValue: leadGenerationContext.employmentInformation.employmentStatus,
            })}
            autoComplete="off"
            slotProps={{
              notchedOutline: {
                sx: commonStyles.notchedOutline,
              },
            }}
          />
        </Grid>
      )}
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="employer"
          required={!isBundleCompliance}
          id="employer_label"
          data-testid="employer_label"
          aria-label={`${t('Employer', { defaultValue: 'Employer' })} ${t(REQUIRED, {
            defaultValue: REQUIRED,
          })}`}
          sx={commonStyles.label_title}
        >
          {productMapping(leadGenerationContext.productName) === 'Elite Account' ||
          productMapping(leadGenerationContext.productName) === 'Libre' ||
          productMapping(leadGenerationContext.productName) === 'Ahorra' ? (
            t('EmployerProg', {
              defaultValue: 'Employer',
              nsSeparator: '|',
            })
          ) : isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.employer
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Employer', { defaultValue: 'Employer' })}
            </span>
          ) : (
            t('Employer', {
              defaultValue: 'Employer',
            })
          )}
        </InputLabel>
        <OutlinedInput
          id="employer"
          name="employer"
          inputProps={{ maxLength: 40, style: { fontSize: '16px' } }}
          data-testid="employer_testid"
          sx={[
            commonStyles.outlined_inputs,
            classes.input_disabled_style,

            ...(isBundleCompliance
              ? [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors.employer
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors.employer
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  },
                ]
              : []),
          ]}
          slotProps={{
            notchedOutline: {
              sx:
                leadGenerationContext.employmentInformationErrors?.employer && !isBundleCompliance
                  ? commonStyles.notchedOutlineErr
                  : leadGenerationContext.employmentInformationErrors?.employer &&
                    isBundleCompliance
                  ? classes.outline_inputs_err_bundle
                  : commonStyles.notchedOutline,
            },
            input: {
              sx: isBundle(productName) && {
                '::-moz-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::-webkit-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::-ms-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
              },
            },
          }}
          onChange={handleChange}
          placeholder={
            isBundleCompliance
              ? t(EMPLOYER_DETAILS, {
                  defaultValue: EMPLOYER_DETAILS,
                })
              : t(EMP_PLACEHOLDER, {
                  defaultValue: EMP_PLACEHOLDER,
                })
          }
          fullWidth
          disabled={
            !!(
              productMapping(leadGenerationContext.productName) === PROGRESA_CONTIGO &&
              leadGenerationContext.organization !== ''
            )
          }
          readOnly={
            !!(
              productMapping(leadGenerationContext.productName) === PROGRESA_CONTIGO &&
              leadGenerationContext.organization !== ''
            )
          }
          value={
            leadGenerationContext.employmentInformation?.employer
              ? leadGenerationContext.employmentInformation?.employer
              : ''
          }
          autoComplete="off"
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="employer_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors?.employer, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.employer,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="occupation"
          required={!isBundleCompliance}
          data-testid="occupation_label"
          aria-label={
            isBundleCompliance
              ? `${t('Profession', { defaultValue: 'Profession' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
              : `${t('Occupation', { defaultValue: 'Occupation' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
          }
          sx={commonStyles.label_title}
        >
          {productMapping(leadGenerationContext.productName) === 'Elite Account' ||
          productMapping(leadGenerationContext.productName) === 'Libre' ||
          productMapping(leadGenerationContext.productName) === 'Ahorra' ? (
            t('OccupationProg', {
              defaultValue: 'Occupation',
              nsSeparator: '|',
            })
          ) : isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.occupation
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Profession', { defaultValue: 'Profession' })}
            </span>
          ) : (
            t('Occupation', { defaultValue: 'Occupation' })
          )}
        </InputLabel>
        <Autocomplete
          id="occupation"
          name="occupation"
          options={sortedOccupation}
          data-testid="autocomplete"
          getOptionLabel={(option) => option}
          value={
            leadGenerationContext.employmentInformation?.occupation
              ? leadGenerationContext.employmentInformation?.occupation
              : null
          }
          onChange={(event, selectedValue) => {
            handleAutoCompleteChangeEmployed('occupation', selectedValue);
          }}
          renderInput={(params) => (
            <OutlinedInput
              inputProps={{
                ...params.inputProps,
              }}
              ref={params.InputProps.ref}
              id="occupation"
              name="occupation"
              sx={[
                commonStyles.outlined_inputs,
                ...(isBundleCompliance
                  ? [
                      {
                        '&.Mui-focused': {
                          border: `1px solid ${theme?.palette?.primary?.main}`,
                        },
                      },
                      classes.select_inputs_bundleBorder,
                      commonStyles.outlined_input_bundle,
                      {
                        backgroundColor: leadGenerationContext.employmentInformationErrors
                          .occupation
                          ? '#D5151F1A'
                          : theme?.palette?.fieldsBackground?.main,
                        // border: leadGenerationContext.employmentInformationErrors.occupation
                        //   ? `1px solid ${theme?.palette?.danger?.main}`
                        //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                      },
                    ]
                  : []),
                {
                  padding: !isBundleCompliance && '11.5px 14px !important',
                  fontSize: '16px',
                },
              ]}
              slotProps={{
                notchedOutline: {
                  sx:
                    leadGenerationContext.employmentInformationErrors?.occupation &&
                    !isBundleCompliance
                      ? commonStyles.notchedOutlineErr
                      : leadGenerationContext.employmentInformationErrors?.occupation &&
                        isBundleCompliance
                      ? classes.outline_inputs_err_bundle
                      : commonStyles.notchedOutline,
                },
                input: {
                  sx: {
                    fontSize: '16px',
                    ...(isBundle(productName) && {
                      padding: '14px 14px 10px 14px !important',
                      '::-moz-placeholder': {
                        color: theme?.palette?.fieldsPlaceholder?.main,
                        opacity: 1,
                      },
                      '::placeholder': {
                        color: theme?.palette?.fieldsPlaceholder?.main,
                        fontSize: '16px',
                        opacity: 1,
                      },
                      '::-webkit-input-placeholder': {
                        color: theme?.palette?.fieldsPlaceholder?.main,
                        opacity: 1,
                      },
                      '::-ms-input-placeholder': {
                        color: theme?.palette?.fieldsPlaceholder?.main,
                        opacity: 1,
                      },
                    }),
                  },
                },
              }}
              placeholder={
                isBundleCompliance
                  ? t(PROFESSION_DETAILS, {
                      defaultValue: PROFESSION_DETAILS,
                    })
                  : t(OCC_PLACEHOLDER, {
                      defaultValue: OCC_PLACEHOLDER,
                    })
              }
              fullWidth
              value={
                leadGenerationContext.employmentInformation?.occupation
                  ? leadGenerationContext.employmentInformation?.occupation
                  : ''
              }
            />
          )}
          filterOptions={filterOptions}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: theme?.menuBackground,
                color: theme?.palette?.primary?.main,
              },
            },
          }}
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="ocuupation_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors.occupation, {
            defaultValue: leadGenerationContext.employmentInformationErrors.occupation,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          required={!isBundleCompliance}
          id="annualIncome_label"
          aria-label={
            isBundleCompliance
              ? `${t('Annual income', {
                  defaultValue: 'Annual income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Annual Income', {
                  defaultValue: 'Annual Income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
          sx={commonStyles.label_title}
          htmlFor="annualIncome"
          data-testid="annualIncome_label"
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.annualIncome
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Annual income', { defaultValue: 'Annual income' })}
            </span>
          ) : (
            t('Annual Income', { defaultValue: 'Annual Income' })
          )}
        </InputLabel>
        <Select
          id="annualIncome"
          name="annualIncome"
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          role="listbox"
          data-testid="select_testid"
          fullWidth
          variant="outlined"
          aria-label={t('Annual Income Aria Label', {
            defaultValue: 'Annual Income Required Please Select Annual Income dropdown menu button',
          })}
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                ...theme?.menuBackground,
                border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                color: theme?.palette?.primary?.main,
              },
              className: isBundleCompliance ? 'bundle-menu-paper' : '',
            },
          }}
          sx={[
            classes.select_inputs,
            leadGenerationContext.employmentInformationErrors?.annualIncome && !isBundleCompliance
              ? classes.select_inputs_err
              : null,
            leadGenerationContext.employmentInformationErrors?.annualIncome && isBundleCompliance
              ? classes.select_inputs_err_bundle
              : null,
            !leadGenerationContext.employmentInformation?.annualIncome
              ? { color: '#808285' }
              : null,
            ...(isBundleCompliance
              ? [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors.annualIncome
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors.annualIncome
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                    color: !leadGenerationContext.employmentInformation?.annualIncome
                      ? theme?.palette?.fieldsPlaceholder?.main
                      : theme?.palette?.primary?.main,
                  },
                ]
              : []),
          ]}
          // sx={[
          //   classes.select_inputs,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     !isBundleCompliance &&
          //     classes.select_inputs_err,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     isBundleCompliance &&
          //     classes.select_inputs_err_bundle,
          //   !leadGenerationContext.employmentInformation?.annualIncome && {
          //     color: '#808285',
          //   },
          //   ...(isBundleCompliance && [
          //     classes.select_inputs_bundleBorder,
          //     commonStyles.outlined_input_bundle,
          //   ]),
          // ]}
          onChange={handleChange}
          slotProps={{
            icon: {
              sx: classes.select_icon,
            },
            select: {
              sx: [
                !leadGenerationContext.employmentInformation?.annualIncome ||
                leadGenerationContext.employmentInformation?.annualIncome === PLEASE_SELECT
                  ? classes.select_inputs_placeholder
                  : classes.select_style,
              ],
            },
            notchedOutline: {
              sx: isBundle(leadGenerationContext.productName) && { border: 'none' },
            },
          }}
          displayEmpty
          value={
            leadGenerationContext.employmentInformation?.annualIncome
              ? leadGenerationContext.employmentInformation?.annualIncome
              : ''
          }
        >
          <MenuItem role="option" value="">
            {isBundleCompliance
              ? t('Select your annual income', { defaultValue: 'Select your annual income' })
              : t('Select Annual Income', { defaultValue: 'Select Annual Income' })}
          </MenuItem>
          <MenuItem role="option" value="Less than $30,000">
            {t('Less than', { defaultValue: 'Less than' })} $30,000
          </MenuItem>
          <MenuItem role="option" value="$30,000 - $49,999">
            {t('$30,000 - $49,999', { defaultValue: '$30,000 - $49,999' })}
          </MenuItem>
          <MenuItem role="option" value="$50,000 - $74,999">
            {t('$50,000 - $74,999', { defaultValue: '$50,000 - $74,999' })}
          </MenuItem>
          <MenuItem role="option" value="$75,000 - $99,999">
            {t('$75,000 - $99,999', { defaultValue: '$75,000 - $99,999' })}
          </MenuItem>
          <MenuItem role="option" value="$100,000 - $199,999">
            {t('$100,000 - $199,999', { defaultValue: '$100,000 - $199,999' })}
          </MenuItem>
          <MenuItem role="option" value="$200,000 or More">
            $200,000 {t('or More', { defaultValue: 'or More' })}
          </MenuItem>
        </Select>
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="select_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors.annualIncome, {
            defaultValue: leadGenerationContext.employmentInformationErrors.annualIncome,
          })}
        </Box>
      </Grid>
    </>
  );
}

export default Employed;

Employed.propTypes = {
  isBundleCompliance: PropTypes.bool,
};
